import React, { Suspense, useState } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { CssBaseline } from "@material-ui/core";
import createTheme from "@material-ui/core/styles/createTheme";
import { ThemeProvider } from "@material-ui/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { theme as customTheme } from "./themes/walserberg";
import {
	AppContext,
	BookmarkContext,
	MenuContext,
	PageContext,
	UserContext,
	UserMenuContext,
	ChangePage
} from "@micado-digital/react-intown-core";
import MomentUtils from "@date-io/moment";
import ReactGA from "react-ga";
import DetectPage from "./helper/detectPage";
import "./index.css";

const themeDefault = createTheme(customTheme);
const themeGrey = createTheme(customTheme, { palette: { background: { default: "#ebebe8" } } });

const App = () => {
	const { REACT_APP_GOOGLE_ANALYTICS_ID } = process.env;
	const [appData, setAppData] = useState();
	const [pageData, setPageData] = useState();
	const [userData, setUserData] = useState();
	const [menuOpen, setMenuOpen] = useState(false);
	const [userMenuOpen, setUserMenuOpen] = useState(false);
	const [bookmarkContext, setBookmarkContext] = useState(JSON.parse(localStorage.getItem("bookmark")) || []);

	const queryClient = new QueryClient();

	if (REACT_APP_GOOGLE_ANALYTICS_ID) ReactGA.initialize(REACT_APP_GOOGLE_ANALYTICS_ID);

	return (
		<QueryClientProvider client={queryClient}>
			<Suspense fallback={<></>}>
				<ThemeProvider theme={pageData?.theme === "grey" ? themeGrey : themeDefault}>
					<AppContext.Provider value={[appData, setAppData]}>
						<PageContext.Provider value={[pageData, setPageData]}>
							<UserContext.Provider value={[userData, setUserData]}>
								<MenuContext.Provider value={[menuOpen, setMenuOpen]}>
									<UserMenuContext.Provider value={[userMenuOpen, setUserMenuOpen]}>
										<BookmarkContext.Provider value={[bookmarkContext, setBookmarkContext]}>
											<MuiPickersUtilsProvider utils={MomentUtils}>
												<CssBaseline />
												<Router>
													<ChangePage />
													<Switch>
														<Route path="/*" component={DetectPage} />
													</Switch>
												</Router>
											</MuiPickersUtilsProvider>
										</BookmarkContext.Provider>
									</UserMenuContext.Provider>
								</MenuContext.Provider>
							</UserContext.Provider>
						</PageContext.Provider>
					</AppContext.Provider>
				</ThemeProvider>
			</Suspense>
		</QueryClientProvider>
	);
};

ReactDOM.render(<App />, document.getElementById("root"));
